/* BANS with B — piezas propias sobre Dawn: ventanas, «Completa el look» y barra fija. */
(function () {
  'use strict';

  /* ---------- Dinero (formato de la tienda, importes en céntimos) ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = parseInt(cents, 10) || 0;
    format = format || '{{amount_with_comma_separator}} €';
    if (/[<&]/.test(format)) {
      var tmp = document.createElement('div');
      tmp.innerHTML = format;
      format = tmp.textContent;
    }
    function fmt(number, precision, thousands, decimal) {
      var n = (number / 100.0).toFixed(precision);
      var parts = n.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return parts[1] ? whole + decimal + parts[1] : whole;
    }
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!match) return format;
    var value;
    switch (match[1]) {
      case 'amount': value = fmt(cents, 2, ',', '.'); break;
      case 'amount_no_decimals': value = fmt(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = fmt(cents, 2, "'", '.'); break;
      case 'amount_with_space_separator': value = fmt(cents, 2, ' ', ','); break;
      default: value = fmt(cents, 2, '.', ',');
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  /* ---------- Ventanas (guía de tallas) ---------- */
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-bwb-dialog-open]');
    if (opener) {
      var dlg = document.getElementById(opener.getAttribute('data-bwb-dialog-open'));
      if (dlg && typeof dlg.showModal === 'function') {
        dlg.showModal();
        document.body.classList.add('overflow-hidden');
      }
      return;
    }
    if (e.target.closest('[data-bwb-dialog-close]')) {
      var d = e.target.closest('dialog');
      if (d) d.close();
      return;
    }
    // Clic fuera del contenido (en el fondo oscuro) cierra.
    if (e.target.tagName === 'DIALOG' && e.target.classList.contains('bwb-dialog')) e.target.close();
  });
  document.addEventListener(
    'close',
    function (e) {
      if (e.target.classList && e.target.classList.contains('bwb-dialog')) document.body.classList.remove('overflow-hidden');
    },
    true
  );

  /* ---------- «Completa el look» ---------- */
  function initBundle(root) {
    if (root.dataset.bwbReady) return;
    root.dataset.bwbReady = '1';
    var formatEl = root.querySelector('[data-bwb-money-format]');
    var moneyFormat = formatEl ? JSON.parse(formatEl.textContent) : null;
    var multiplier = parseFloat(root.dataset.multiplier) || 1;

    function selected() {
      return Array.prototype.map.call(root.querySelectorAll('[data-bwb-bundle-variant]'), function (el) {
        var price = el.tagName === 'SELECT' ? el.options[el.selectedIndex].dataset.price : el.dataset.price;
        return { id: parseInt(el.value, 10), price: parseInt(price, 10) || 0, el: el };
      });
    }

    function refresh() {
      var items = selected();
      var sum = items.reduce(function (acc, it) { return acc + it.price; }, 0);
      var total = Math.round(sum * multiplier);
      var totalEl = root.querySelector('[data-bwb-bundle-total]');
      var compareEl = root.querySelector('[data-bwb-bundle-compare]');
      if (totalEl) totalEl.textContent = formatMoney(total, moneyFormat);
      if (compareEl) compareEl.textContent = total < sum ? formatMoney(sum, moneyFormat) : '';
    }

    root.addEventListener('change', function (e) {
      var sel = e.target.closest('[data-bwb-bundle-variant]');
      if (!sel || sel.tagName !== 'SELECT') return;
      var opt = sel.options[sel.selectedIndex];
      var item = sel.closest('[data-bwb-bundle-item]');
      var priceEl = item && item.querySelector('[data-bwb-bundle-price]');
      if (priceEl) priceEl.textContent = opt.dataset.priceText;
      var img = item && item.querySelector('.bwb-bundle__img');
      if (img && opt.dataset.img) {
        img.removeAttribute('srcset');
        img.src = opt.dataset.img;
      }
      refresh();
    });

    var button = root.querySelector('[data-bwb-bundle-add]');
    var errorEl = root.querySelector('[data-bwb-bundle-error]');
    if (button) {
      button.addEventListener('click', function () {
        var items = selected().map(function (it) { return { id: it.id, quantity: 1 }; });
        button.setAttribute('aria-disabled', 'true');
        button.classList.add('loading');
        if (errorEl) errorEl.hidden = true;
        var root_url = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        fetch(root_url + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items }),
        })
          .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error(res.data.description || res.data.message || 'Error');
            window.location.href = (window.routes && window.routes.cart_url) || root_url + 'cart';
          })
          .catch(function (err) {
            if (errorEl) {
              errorEl.textContent = err.message;
              errorEl.hidden = false;
            }
            button.removeAttribute('aria-disabled');
            button.classList.remove('loading');
          });
      });
    }
    refresh();
  }

  /* ---------- Barra fija de «Añadir al carrito» ---------- */
  function initSticky(bar) {
    if (bar.dataset.bwbReady) return;
    bar.dataset.bwbReady = '1';
    var stickyBtn = bar.querySelector('[data-bwb-sticky-button]');
    // El botón principal se busca SIEMPRE de nuevo: Dawn puede redibujarlo al cambiar de talla,
    // y uno guardado al principio dejaría la barra pulsando un botón que ya no está en la página.
    function mainBtn() {
      var form = document.getElementById(bar.dataset.formId);
      return form && form.querySelector('button[name="add"]');
    }
    if (!mainBtn() || !stickyBtn) return;
    // Fuera de la sección: un antepasado con animación (transform) rompería el position: fixed.
    document.querySelectorAll('body > [data-bwb-sticky][data-form-id="' + bar.dataset.formId + '"]').forEach(function (old) {
      if (old !== bar) old.remove();
    });
    document.body.appendChild(bar);
    stickyBtn.dataset.label = stickyBtn.textContent.trim();

    function show(visible) {
      bar.classList.toggle('is-visible', visible);
      bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
      stickyBtn.tabIndex = visible ? 0 : -1;
    }
    var pending = false;
    function update() {
      pending = false;
      var btn = mainBtn();
      if (!btn) return show(false);
      // Mismo estado que el principal (p. ej. «Agotado»).
      stickyBtn.disabled = btn.disabled;
      var label = btn.querySelector('span');
      stickyBtn.textContent = btn.disabled && label ? label.textContent.trim() : stickyBtn.dataset.label;
      // Solo cuando el botón principal ya quedó ARRIBA (se ha bajado), no antes de llegar a él.
      show(btn.getBoundingClientRect().bottom < 0);
    }
    function schedule() {
      if (!pending) { pending = true; window.requestAnimationFrame(update); }
    }
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    document.addEventListener('change', schedule);
    update();

    stickyBtn.addEventListener('click', function () {
      var btn = mainBtn();
      if (btn && !btn.disabled) btn.click();
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      var priceEl = bar.querySelector('[data-bwb-sticky-price]');
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        var variant = event && event.data && event.data.variant;
        if (priceEl && variant) priceEl.textContent = formatMoney(variant.price, window.bwbMoneyFormat);
        // El botón puede pasar a «Agotado» un instante después de este aviso.
        window.setTimeout(schedule, 300);
      });
    }
  }

  /* ---------- Cuenta atrás del carrito ----------
     Dawn redibuja el carrito entero al cambiar algo, así que no se guarda ninguna
     referencia: cada segundo se busca el reloj de nuevo. El final se guarda por sesión
     para que no vuelva a empezar en cada página. */
  var TIMER_KEY = 'bwb-cart-timer-end';
  function tickCartTimer() {
    var timers = document.querySelectorAll('[data-bwb-cart-timer]');
    if (!timers.length) return;
    var end = null;
    try { end = parseInt(window.sessionStorage.getItem(TIMER_KEY), 10); } catch (e) {}
    if (!end || isNaN(end)) {
      end = Date.now() + (parseInt(timers[0].dataset.minutes, 10) || 5) * 60000;
      try { window.sessionStorage.setItem(TIMER_KEY, String(end)); } catch (e) {}
    }
    var left = Math.max(0, Math.round((end - Date.now()) / 1000));
    var text = Math.floor(left / 60) + ':' + ('0' + (left % 60)).slice(-2);
    timers.forEach(function (t) {
      t.querySelectorAll('[data-bwb-cart-timer-clock]').forEach(function (c) { c.textContent = text; });
    });
  }
  window.setInterval(tickCartTimer, 1000);

  function init(scope) {
    tickCartTimer();
    (scope || document).querySelectorAll('[data-bwb-bundle]').forEach(initBundle);
    (scope || document).querySelectorAll('[data-bwb-sticky]').forEach(initSticky);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  // En el editor de temas las secciones se recargan sin recargar la página.
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
